<template>
    <v-container class="max-container">
        <v-row v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl">
            <v-btn class="text-none" color="#EE5D09" text @click="returnToListOfSweepstakes()">Voltar</v-btn>                        
        </v-row>
        <v-row>
            <v-col :class="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm ? 'flex-col-center no-pd' : 'no-pd-t no-pd-l no-pd-b'"  xs="12" sm="12" md="4" lg="4" xl="4">
                <span v-if=" ($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) && activatedPoint " class="sweepstakes--participating mdi mdi-checkbox-marked-circle-outline"> Você está participando</span>
            
                <v-img :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 'vrow_vcol___img--mobile' : 'vrow_vcol___img' " :src="sweepstakeObject.banner ?sweepstakeObject.banner : '@/assets/sweepstakes/default_sorteio_web.png' "/>

                <v-btn 
                    v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm && !activatedPoint" 
                    class="text-none w-100 principal__button " 
                    :color="currentCompany.primaryColor"
                    style="margin-top: 12px"
                    :loading="btnLoading"
                    @click="activateLuckyNumber()"
                >
                    <span style="color: white">Ativar número da sorte</span>
                </v-btn>
                
                <v-btn v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm && rulesPoint" text color="#EE5D09" @click="seeRegularity(sweepstakeObject.rules)">Ver regulamento</v-btn>
            </v-col>
            <v-col :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 'flex-col-start' : 'flex-cunstom no-pd-t'" xs="12" sm="12" md="8" lg="8" xl="8">
                <v-col class="flex-col-start no-pd" xs="12" sm="12" md="4" lg="4" xl="4">
                        <div  v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm && activatedPoint" class="flex-row-start">                            
                            <span class="sweepstakes--participating mdi mdi-checkbox-marked-circle-outline"> Você está participando</span>
                        </div>

                        <div class="flex-row-start">                            
                            <span class="vrow_vcol_sweepstakes__title">{{ ( sweepstakeObject && sweepstakeObject.title ) ? sweepstakeObject.title : '-' }}</span>
                            <v-btn v-if="($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) && rulesPoint" text color="#EE5D09" @click="seeRegularity(sweepstakeObject.rules)">Ver regulamento</v-btn>
                        </div> 

                        <div class="flex-col-start vrow_vcol_div--info">
                            <span class="vrow_vcol__infotitle">Data início:</span>
                            <span class="vrow_vcol_infodescritpion">{{ ( sweepstakeObject && sweepstakeObject.dateStart ) ? ( getDateByTimeStamp( sweepstakeObject.dateStart ) + ' - ' + getHourByTimeStamp( sweepstakeObject.dateStart ) ) : '-' }}</span>
                        </div>

                        <div class="flex-col-start vrow_vcol_div--info">
                            <span class="vrow_vcol__infotitle">Data final da inscrição:</span>
                            <span class="vrow_vcol_infodescritpion">{{ ( sweepstakeObject && sweepstakeObject.dateEnd ) ? ( getDateByTimeStamp( sweepstakeObject.dateEnd ) + ' - ' + getHourByTimeStamp( sweepstakeObject.dateEnd ) ) : '-' }}</span>
                        </div>

                        <div class="flex-col-start vrow_vcol_div--info" :style="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm ? 'padding-bottom: 0px !important;' : '' ">
                            <span class="vrow_vcol__infotitle">Data do sorteio:</span>
                            <span class="vrow_vcol_infodescritpion">{{ ( sweepstakeObject && sweepstakeObject.dateDraw ) ? ( getDateByTimeStamp( sweepstakeObject.dateDraw ) + ' - ' + getHourByTimeStamp( sweepstakeObject.dateDraw ) ) : '-' }}</span>
                        </div>
                </v-col>

                <v-col class="flex-col-start no-pd" xs="12" sm="12" md="8" lg="8" xl="8" :style="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm ? 'padding-top: 67px !important;' : '' ">
                        <div class="flex-col-start vrow_vcol_div--info" :style="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm ? 'padding-top: 0px;' : '' ">
                            <span class="vrow_vcol__infotitle">Regras:</span>
                            <span class="vrow_vcol_infodescritpion">{{( sweepstakeObject && sweepstakeObject.instructions ) ? sweepstakeObject.instructions : '-'}}</span>
                        </div>

                        <div class="flex-col-start vrow_vcol_div--info">
                            <span class="vrow_vcol__infotitle">Informações:</span>
                            <span class="vrow_vcol_infodescritpion">{{( sweepstakeObject && sweepstakeObject.description ) ? sweepstakeObject.description : '-'}}</span>
                        </div>

                        <div class="flex-col-start vrow_vcol_div--info">
                            <span class="vrow_vcol__infotitle">Seus números da sorte:</span>
                            <v-container class="no-pd flex-row-start flex-wrap container--overflow" v-if="hasLuckyNumbers">
                                <span
                                class="vrow_vcol_infodescritpion"
                                style="padding-right: 6px"
                                v-for="(luckyNumber, index) in sweepstakeObject.luckyNumbers" 
                                :key="index"
                                >{{ luckyNumber + ';'}}</span>
                            </v-container>
                            <span class="vrow_vcol_infodescritpion" v-else>Nenhum número da sorte</span>
                        </div>
           
                        <v-btn 
                            v-if="($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) && !activatedPoint" 
                            class="text-none w-100 principal__button " 
                            :color="currentCompany.primaryColor"
                            style="margin-top: 12px"
                            :loading="btnLoading"
                            activateLuckyNumber()
                        >
                            <span style="color: white">Ativar número da sorte</span>
                        </v-btn>
                </v-col>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

//Store
import { mapActions, mapGetters } from "vuex";

//Services
import { activateRaffleByIdAndCompanyIdAndCurrentContactId } from "@/app/components/sweepstakes/service/sweepstakes.service";

export default {
    name: 'sweepstakesDetail',
    props: {
        sweepstakeObject: {
            type: Object
        },
        sweepstakesId: {
            type: Number
        }
    },
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },   
    data: () => ({
        //Controle
        hasLuckyNumbers: false,        
        activatedPoint: true, //Ao carregar a pagina o botão não existe.
        rulesPoint: false,   //   ~ ~
        btnLoading: false,
    }),
     watch: {
        sweepstakeObject: {
            deep: true,
            handler() {
                this.sweepstakeObject.luckyNumbers.lenght > 0 ? this.hasLuckyNumbers = true : this.hasLuckyNumbers = false
                this.sweepstakeObject.activated ? this.activatedPoint = true : this.activatedPoint = false 
                this.sweepstakeObject.rules !== null ? this.rulesPoint = true : this.rulesPoint = false
            }
        }
    },
    methods: {
        ...mapActions('routeStore', ['RETURN_TO_PREVIOUS_ROUTE']),
        getHourByTimeStamp( data ){
            var moment = require('moment')
            var formatted = moment(data).format("HH:mm")
            return formatted
        },
        getDateByTimeStamp( data ){
            var moment = require('moment')
            var formatted =  moment(data).format("DD/MM/YYYY")
            return formatted;
        },
        returnToListOfSweepstakes() {
            this.$router.push('/sorteios')
        },
        activateLuckyNumber() {
            this.btnLoading = true
            activateRaffleByIdAndCompanyIdAndCurrentContactId(this.currentCompany.id, this.sweepstakesId)
                .then( () => {
                        this.btnLoading = false
                        this.activatedPoint = true
                        this.$toasted.show('Número da sorte ativado com sucesso.', { type: 'success' })                        
                    }
                )
                .catch( error => {
                        this.btnLoading = false
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        seeRegularity(rulesLink) {
            window.open(rulesLink, '_blank')
        }
    }
}
</script>

<style scoped>
.flex-cunstom {
    display: flex;
    flex: auto;
    flex-direction: row;
    align-items: flex-start;
}
.sweepstakes--participating {
    color: var(--cor--verde);
    font-size: 16px;
    font-weight: 600;
}
.vrow_vcol___img {
    max-height: 248px;
    min-height: 248px;
}
.vrow_vcol___img--mobile {
    max-height: 200px;
    min-height: 200px;
}
.vrow_vcol_sweepstakes__title {
    font-size: 18px;
    font-weight: 800;
    color: var(--cor--preta);
}
.vrow_vcol_div--info {
    padding: 12px 0px;
}
.vrow_vcol__infotitle {
    font-weight: bold;
    font-size: 16px;
    color: var(--cor--preta);
}
.vrow_vcol_infodescritpion {
    font-size: 15px;
    color: var(--cor--cinzaApp)
}
.container--overflow {
   overflow-x: scroll;
   max-height: 54px;
}
</style>